import { addDays, format, subMonths } from "date-fns";
import { ActionDashboardActionType, PatientFiltersState, PatientFilterStateActions } from "./types";


export const initialState: (payload?: PatientFiltersState) => PatientFiltersState = (payload?: PatientFiltersState) => {
  if (payload) return payload;
  return {
    start_date: format(subMonths(new Date(), 2), 'yyyy-MM-dd'),
    end_date: format(addDays(new Date(), 1), 'yyyy-MM-dd'),
    case_id: "",
    global_patient_id: "",
    global_doctor_id: "",
    search_str:"",
    patient_name:"",
    global_patient_external_id:"",
    practice_id: "",
    pending_therapy_page: 1,
    on_therapy_page: 1,
    off_therapy_page: 1,
    ref_user:'',
    role:"",
    id:"",
    pagination: true,
  }
};

export const tableFilterReducer = (state: PatientFiltersState, action: ActionDashboardActionType): PatientFiltersState => {
  switch (action.type) {
    case PatientFilterStateActions.SET_QUERY_PARAMS:
      return {
        ...state,
        ...action.payload,
      };

    case PatientFilterStateActions.SET_REF_USER:
      return {
        ...state,
        ref_user: action.payload,
      };

    case PatientFilterStateActions.CHANGE_OFF_THERAPY_PAGE:
      return {
        ...state,
        off_therapy_page: action.payload
      };

    case PatientFilterStateActions.CHANGE_ON_THERAPY_PAGE:
      return {
        ...state,
        on_therapy_page: action.payload,
      };

    case PatientFilterStateActions.CHANGE_PENDING_THERAPY_PAGE:
      return {
        ...state,
        pending_therapy_page: action.payload,
      };

    case PatientFilterStateActions.CHANGE_USER_ROLE_AND_ID:
      return {
        ...state,
        role: action.payload.role,
        id: action.payload.id,
        ref_user: action.payload.ref_user,
      };

    case PatientFilterStateActions.CHANGE_PAGINATION_BIT:
      return {
        ...state,
        pagination: action.payload
      }
    case PatientFilterStateActions.RESET_FILTERS:
      return {
        ...initialState(),
        ...action.payload
      };

    default:
      return state;
  }
};
